import { render, staticRenderFns } from "./PredefinedSubField.vue?vue&type=template&id=359de577"
import script from "./PredefinedSubField.vue?vue&type=script&lang=js"
export * from "./PredefinedSubField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports